<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Referral Details

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

               

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label class="margin-bottom-0px margin-top-8px"><span>*</span> Referral Type</label>
                      </div>

                      <div class="col-md-5">

                        <!--<input type="text" class="form-control" placeholder="Type"/>-->
                        <CodeTypeValue CodeType="RFTP"></CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label class="margin-bottom-0px margin-top-8px"> Referral Name</label>
                      </div>
                      <div class="col-md-5">

                        <input type="text" class="form-control" placeholder="Referral Name"/>

                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right">
                        <label class="margin-bottom-0px margin-top-8px"><span>*</span> Referral Contact </label>
                      </div>
                      <div class="col-md-5">
                        <input type="tel" class="form-control"
                             mask="(000-000-0000)" pattern="[0-9]{10}" placeholder="Mobile Phone" />                               
                               
                 </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right ">
                        <label class="margin-bottom-0px margin-top-8px">Referral Institute </label>
                      </div>
                      <div class="col-md-5 ">
                        <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                        <!--id="CurrentActorPersonalDetailInfoRequest.City"
                               [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                               name="CurrentActorPersonalDetailInfoRequest.City"
                                maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                        <small class="form-text text-danger"
                               *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                        <!--<label>Hyderabad</label>-->
                        <input type="text" class="form-control" placeholder="Institute"/>                         
                 </div>
                    </div>


                  </div>
                </div>

              


              </div>
            </div>


         

















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
